"use client";
import clsx from "clsx";
import { FC } from "react";
import MiniCart from "@/components/Cart/MiniCart/MiniCart";
import useStoreKeys from "@/hooks/useStoreKeys";
import { useHeader } from "../hooks/useHeader";
import { CategoryTree } from "@/lib/5874/types";
import { HeaderStoreBuilderContent } from "../headerTypes";
import HeaderBurgerButton from "../HeaderBurgerButton/HeaderBurgerButton";
import HeaderLogo from "../HeaderLogo/HeaderLogo";
import LoginModal from "./LoginModal/LoginModal";
import Nav from "./Nav/Nav";
import SearchBar from "./SearchBar/SearchBar";
import styles from "./Header.module.scss";

interface HeaderProps {
	bigCommerceMenu: CategoryTree[];
	builderMenuContent: HeaderStoreBuilderContent;
	accountAreaConfig?: any;
}

const Header: FC<HeaderProps> = ({
	bigCommerceMenu,
	builderMenuContent,
	accountAreaConfig,
}) => {
	const { openMobileMenu, handleOpenMobileMenu } = useHeader();
	const { store, lang } = useStoreKeys();

	return (
		<header className={styles.header}>
			<div className={clsx([styles.layout])}>
				<div className={styles.top}>
					<div className={styles.burgerAndLogo}>
						<HeaderBurgerButton
							isOpen={false}
							onButtonClick={() => handleOpenMobileMenu(true)}
							ariaLabel={"Open main navigation menu"}
						/>
						<HeaderLogo
							url={builderMenuContent.logo?.url}
							altText={builderMenuContent.logo?.altText}
							href={`/${store}/${lang}`}
						/>
					</div>
					<SearchBar
						placeHolderText={builderMenuContent.searchBar?.text}
						ariaLabel={builderMenuContent.searchBar?.ariaLabel}
						className={styles.search}
					/>
					<div className={styles.loginAndCart}>
						<LoginModal accountAreaConfig={accountAreaConfig} />
						<MiniCart />
					</div>
				</div>
				<Nav
					bigCommerceMenu={bigCommerceMenu}
					builderMenuContent={builderMenuContent}
					openMobileMenu={openMobileMenu}
					setOpenMobileMenu={handleOpenMobileMenu}
				/>
			</div>
		</header>
	);
};

export default Header;
